import { FC, useState, useEffect } from 'react'
import { Divider, IconButton, Panel } from 'rsuite'
import { FaUserCircle, FaLink, FaPhoneAlt } from 'react-icons/fa'
import { MdMail, MdLocationOn } from 'react-icons/md'
import EditIcon from '@rsuite/icons/Edit'
import DocumentCard from 'shared/molecules/cardTable/DocumentCard'
import useAuth from '../../../hooks/Auth'
import PROFILE from '../../../assets/images/profile.png'
import CreateEditProfile from '../createEditProfile/createEditProfile'
import DocumentEditProfile from '../createEditProfile/documentProfile'
import { useGetProfileQuery } from '../profileApiSlice'
import './profile.scss'
import { Profile } from '../types'

const ProfileList: FC = () => {
  const [openProfile, setOpenProfile] = useState<boolean>(false)
  const [openDocument, setOpenDocument] = useState<boolean>(false)
  const [selectedDocument, setSelectedDocument] = useState<any | null>(null)
  const [profileModalMode, setProfileModalMode] = useState<boolean>(true)
  const [imageTimestamp, setImageTimestamp] = useState(Date.now())
  const [selectRowProfile, setSelectRowProfile] = useState<Profile | null>(null)
  const { loginUserDetails } = useAuth()

  const id = loginUserDetails?.id
  const { data: profileData } = useGetProfileQuery({ id }, { skip: !id })

  const userData = (profileData as any)?.user.companyDTO ?? {}
  const userProfileData = (profileData as any)?.user ?? {}
  const companyData = (profileData as any)?.company ?? {}
  const documents = (profileData as any)?.documentDTOS ?? []

  useEffect(() => {
    if (userProfileData?.imageUrl) {
      setImageTimestamp(Date.now())
    }
  }, [userProfileData?.imageUrl])

  const handleClick = (data: Profile) => {
    setSelectRowProfile(data)
    setProfileModalMode(false)
    setOpenProfile(true)
  }
  const handleDocumentClick = (doc: any) => {
    setSelectRowProfile(profileData as Profile)
    setSelectedDocument(doc)
    setOpenDocument(true)
  }

  const handleClose: () => void = () => {
    setOpenProfile(false)
    setSelectRowProfile(null)
    setOpenDocument(false)
    setSelectedDocument(null)
  }

  return (
    <div className="main-prof-container">
      <Panel className="profile-parent">
        <div className="profile-header">
          <div className="profile-logo-container">
            <img
              src={`${userProfileData?.imageUrl ?? PROFILE}?t=${imageTimestamp}`}
              alt="Profile"
              className="profile-img"
            />
            <IconButton
              icon={<EditIcon className="editIcon" />}
              appearance="subtle"
              className="modal-open-btn"
              onClick={() => handleClick(profileData as Profile)}
            />
          </div>
          <h1 className="heading-profile">
            {`${userData?.user?.firstName ?? '-'} ${userData?.user?.lastName ?? ''}`.trim()}
          </h1>
          <span>{userData?.user?.email ?? '-'}</span>
        </div>
        <div className="profile-content">
          <div className="profile-section company-info">
            <h5>Company Details</h5>
            <Divider />
            <div className="details-grid">
              <div className="detail-item">
                <div className="details-icons">
                  <FaUserCircle className="icon" />
                </div>
                <div className="text">
                  <span className="label">Name</span>
                  <span className="value">{companyData?.name ?? '-'}</span>
                </div>
              </div>
              <div className="detail-item">
                <div className="details-icons">
                  <MdMail className="icon" />
                </div>
                <div className="text">
                  <span className="label">Email</span>
                  <span className="value">{companyData?.email ?? '-'}</span>
                </div>
              </div>
              <div className="detail-item">
                <div className="details-icons">
                  <FaLink className="icon" />
                </div>
                <div className="text">
                  <span className="label">Website</span>
                  <span className="value">
                    {companyData?.websiteUrl ?? '-'}
                  </span>
                </div>
              </div>
              <div className="detail-item">
                <div className="details-icons">
                  <FaPhoneAlt className="icon" />
                </div>
                <div className="text">
                  <span className="label">Mobile</span>
                  <span className="value">{companyData?.phoneNo ?? '-'}</span>
                </div>
              </div>
              <div className="detail-item">
                <div className="details-icons">
                  <MdLocationOn className="icon" />
                </div>
                <div className="text">
                  <span className="label">Address</span>
                  <span className="value">
                    {companyData?.addressLine1 ?? '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="profile-section documents">
            <h5>Company Documents</h5>
            <Divider />
            <div className="document-container">
              {documents.map((doc: any) => (
                <DocumentCard
                  title={doc.documentType}
                  imageUrl={doc.imageUrls}
                  number={doc.documentNo}
                  status={doc.status}
                  data={doc}
                  onEdit={handleDocumentClick}
                />
              ))}
            </div>
          </div>
        </div>

        {openProfile && (
          <CreateEditProfile
            open={openProfile}
            onClose={handleClose}
            isEditMode={profileModalMode}
            setIsEditMode={setProfileModalMode}
            profile={selectRowProfile}
          />
        )}
        {openDocument && (
          <DocumentEditProfile
            open={openDocument}
            onClose={handleClose}
            isEditMode={false}
            profile={selectRowProfile}
            selectedDocument={selectedDocument}
          />
        )}
      </Panel>
    </div>
  )
}

export default ProfileList
